import { Component, OnInit } from "@angular/core";
import { Statement } from "../statement";
import { WorkflowControllerService } from "app/core/workflow/workflow-controller/workflow-controller.service";
import { ActivatedRoute, Router } from "@angular/router";
import { SnackbarConfig, SubscribingComponent } from "app/common";
import { finalize, takeUntil } from "rxjs";
import { StatementService } from "../statement.service";
import { Store } from "@ngrx/store";
import { State } from "app/reducers";
import { SHOW_SNACKBAR } from "app/reducers/actions/snackbar";
import { UserDataService } from "app/users";
import { FinishPagePath } from "app/core/workflow/page-path/statement-page-path/finish-page.path";

@Component({
  selector: "app-send-certificate",
  templateUrl: "./send-certificate.component.html",
  styleUrls: ["./send-certificate.component.scss"],
  standalone: false
})
export class SendCertificateComponent extends SubscribingComponent implements OnInit {
  statement: Statement;
  public statementId: number;
  public password: string;
  public isPasswordValidated = false;
  public errors = [];
  public buttons = [];
  public certificateFile: File;

  constructor(
    private store: Store<State>,
    public workFlowController: WorkflowControllerService,
    private route: ActivatedRoute,
    private statementService: StatementService,
    private router: Router,
    private userDataService: UserDataService
  ) {
    super();
  }

  ngOnInit(): void {
    this.route.params.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params) => {
      this.statementId = parseInt(params["statementId"], 10);
      this.getStatementData(this.statementId);
    });
    this.setButtons();
  }

  displayFile(): void {
    console.log(this.certificateFile);
  }

  public handleFileSelected(file: File): void {
    this.certificateFile = file;
  }

  getStatementData(id: number) {
    this.statementService
      .getStatement(id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response: Statement) => {
          this.statement = response;
          this.workFlowController.init(this.statement);
        },
        () => this.router.navigate(["/new"])
      );
  }

  sendStatement() {
    this.statementService
      .sendStatement(this.statementId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        () => this.router.navigate([FinishPagePath.fullUrl(this.statementId)]),
        (error: any) => {
          const message = error.error[0];
          if (typeof message === "string") {
            this.showSnackbarError(message);
          }
        }
      );
  }

  public handleSetPassword(value: string): void {
    this.password = value;
  }

  public isFileValidated(): boolean {
    if (this.certificateFile === undefined || this.certificateFile === null || this.certificateFile.size === 0)
      return false;
    return true;
  }

  public uploadCertificate(): void {
    this.userDataService
      .uploadOwnCertificateToStatement(this.certificateFile, this.password, this.statementId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response: any) => {
          this.certificateFile = null;
          this.sendStatement();
        },
        (error: any) => {
          this.showSnackbarError(error.error && error.error.length ? error.error[0] : error.error);
        }
      );
  }

  private showSnackbarError(message?: string): void {
    this.store.dispatch({
      type: SHOW_SNACKBAR,
      payload: new SnackbarConfig(message || "COMMON.GLOBAL_ERROR", "ERROR")
    });
  }

  public setButtons() {
    this.buttons = [
      {
        type: "proceed",
        label: "COMMON.SEND",
        action: () => {
          this.uploadCertificate();
        },
        disabled: () => !this.isPasswordValidated || !this.isFileValidated()
      }
    ];
  }
}
